import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = () => {
  try { return JSON.parse(localStorage.getItem("pp_cart") || "[]"); } catch { return []; }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("pp_cart", JSON.stringify(items)); }, [items]);

  const addItem = (item) => {
    const key = `${item.print_id}-${item.size_key}`;
    setItems((prev) => {
      const ex = prev.find((i) => i.key === key);
      if (ex) return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + 1 } : i));
      return [...prev, { ...item, key, quantity: 1 }];
    });
    setOpen(true);
  };
  const updateQty = (key, q) =>
    setItems((prev) => (q <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, quantity: q } : i))));
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const totalQty = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const percentOff = totalQty >= 3 ? 25 : totalQty === 2 ? 15 : 0;
  const discount = (subtotal * percentOff) / 100;
  const total = subtotal - discount;

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, totalQty, subtotal, percentOff, discount, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
